import * as yup from 'yup';
import { isValidYupSchema, yupUtils } from '../../utils/yup/utils';
import { ProjectErrors, ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorForCode, getProjectErrorFromRawError } from '../../utils/errors';
import { Profile } from '../types/profile';

const LessonFavoriteSchema = yup.object().shape({
  createdAt: yupUtils.numberRequired,
  updatedAt: yupUtils.numberRequired,
  linkedContentId: yupUtils.stringRequired(),
  linkedContentTitle: yupUtils.stringRequired(),
  linkedContentType: yupUtils.stringRequired(),
});

const PlaybackStateSchema = yup.object().shape({
  createdAt: yupUtils.numberRequired,
  updatedAt: yupUtils.numberRequired,
  linkedContentId: yupUtils.stringRequired(),
  linkedContentTitle: yupUtils.stringRequired(),
  linkedContentType: yupUtils.stringRequired(),
  progress: yupUtils.numberRequired,
  totalLength: yupUtils.numberRequired,
  isFinished: yupUtils.booleanOptionalNullable, // Deprecated in v2.3.4
});

const StatsSchema = yup.object().shape({
  finishedContent: yupUtils.numberOptionalNullable,
  finishedDailyLessons: yupUtils.numberOptionalNullable,
  longestStreak: yupUtils.numberOptionalNullable,
  dailyStreak: yupUtils.numberOptionalNullable,
});

const GiftSchema = yup.object().shape({
  createdAt: yupUtils.numberRequired,
  context: yupUtils.stringRequired(),
  type: yupUtils.stringRequired(),
  endAt: yupUtils.numberOptionalNullable,
});

export const ProfileSchema = yup.object().shape({
  id: yupUtils.stringRequired(),
  firstName: yupUtils.stringOptionalNullable,
  lastName: yupUtils.stringOptionalNullable,
  createdAt: yupUtils.numberRequired,
  updatedAt: yupUtils.numberRequired,
  campaigns: yupUtils.arrayOptionalNullableOf(yupUtils.stringOptionalNullable),
  targetCampaign: yupUtils.stringOptionalNullable,
  lastCampaign: yupUtils.stringOptionalNullable,
  timezone: yupUtils.stringOptionalNullable,
  lessonFavorites: yupUtils.arrayOptionalNullableOf(LessonFavoriteSchema),
  lessonPlaybackStates: yupUtils.arrayOptionalNullableOf(PlaybackStateSchema),
  stats: StatsSchema.nullable().optional(),
  gifts: yupUtils.arrayOptionalNullableOf(GiftSchema),
  finishedLessons: yupUtils.arrayOptionalNullableOf(yupUtils.stringRequired()),
  revenueCatDiscountLevel: yupUtils.stringOptionalNullable,
  revenueCatReachedDiscountLevel5: yupUtils.booleanOptionalNullable,
});

const processProfile = async (profile: any): Promise<Profile> => {
  return profile;
};

export const parseProfile = async (object: any): Promise<Profile | ProjectErrorType> => {
  try {
    if (await isValidYupSchema(ProfileSchema, object)) {
      return processProfile(object as Profile);
    }
    return getProjectErrorForCode(ProjectErrors.invalidProfile);
  } catch (error) {
    console.log(`[Profile] Error: `, error, `Profile: ${object}`);
    return getProjectErrorFromRawError(error as Error);
  }
};
